import type { BaseRouteType, BaseMethodType } from '../types.ts'
import { z } from "zod";
export const tagsGetMunicipalities_municipalityIdExportsPdf = z.any()
export type TagsGetMunicipalities_municipalityIdExportsPdf = z.infer<typeof tagsGetMunicipalities_municipalityIdExportsPdf>

export const descriptionGetMunicipalities_municipalityIdExportsPdf = z.any()
export type DescriptionGetMunicipalities_municipalityIdExportsPdf = z.infer<typeof descriptionGetMunicipalities_municipalityIdExportsPdf>

export const paramsGetMunicipalities_municipalityIdExportsPdf = z.object({ "municipalityId": z.string().uuid() })
export type ParamsGetMunicipalities_municipalityIdExportsPdf = z.infer<typeof paramsGetMunicipalities_municipalityIdExportsPdf>

export const querystringGetMunicipalities_municipalityIdExportsPdf = z.object({ "from": z.string().date(), "to": z.string().date(), "variant": z.union([z.literal("summary"), z.literal("detailed")]).default("summary") }).strict()
export type QuerystringGetMunicipalities_municipalityIdExportsPdf = z.infer<typeof querystringGetMunicipalities_municipalityIdExportsPdf>

export const responseGetMunicipalities_municipalityIdExportsPdf = z.any()
export type ResponseGetMunicipalities_municipalityIdExportsPdf = z.infer<typeof responseGetMunicipalities_municipalityIdExportsPdf>

interface IGetMunicipalities_municipalityIdExportsPdf extends BaseMethodType {
  tags: TagsGetMunicipalities_municipalityIdExportsPdf,
  description: DescriptionGetMunicipalities_municipalityIdExportsPdf,
  params: ParamsGetMunicipalities_municipalityIdExportsPdf,
  querystring: QuerystringGetMunicipalities_municipalityIdExportsPdf,
  response: ResponseGetMunicipalities_municipalityIdExportsPdf
}
export const URL = '/municipalities/:municipalityId/exports/pdf'
export const validation = {
  get: {
    tags: tagsGetMunicipalities_municipalityIdExportsPdf,
    description: descriptionGetMunicipalities_municipalityIdExportsPdf,
    params: paramsGetMunicipalities_municipalityIdExportsPdf,
    querystring: querystringGetMunicipalities_municipalityIdExportsPdf,
    response: responseGetMunicipalities_municipalityIdExportsPdf
  }
}
export interface Municipalities_municipalityIdExportsPdf extends BaseRouteType {
  get: IGetMunicipalities_municipalityIdExportsPdf
}